import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCBenxehangtable = React.memo(function BCBenxehangtable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [sodonvi, setSodonvi] = React.useState(0);
  const [luotphuongtien, setLuotphuongtien] = React.useState(0);
  const [khoiluonghanghoa, setKhoiluonghanghoa] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Donvi/bcslthbenxehang?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSodonvi(data[0].sodonvi);
            setLuotphuongtien(data[0].luotphuongtien);
            setKhoiluonghanghoa(data[0].khoiluonghanghoa);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>
            Tổng số đơn vị đăng ký hoạt động tại bến
          </td>
          <td className={classes.tablebc_td}>đơn vị</td>
          <td className={classes.tablebc_td}>{sodonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>
            Tổng số lượt phương tiện ra, vào bến
          </td>
          <td className={classes.tablebc_td}>lượt</td>
          <td className={classes.tablebc_td}>{luotphuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>
            Tổng khối lượng hàng hoá thông qua tại bến
          </td>
          <td className={classes.tablebc_td}>1000 tấn</td>
          <td className={classes.tablebc_td}>{khoiluonghanghoa}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaobenxehang" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCBenxehangtable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCBenxehangtable;
